import "../sections/sections.css";
import "./home.css";

import React from "react";

import { TOUR_LINK } from "../../data/content";
import { HOME } from "../../data/home";
import PageMeta from "../general/PageMeta";
import SectionTitle from "../general/SectionTitle";
import CardSection from "../sections/CardSection";
import Nightmares from "../sections/Nightmares";
import EventPopup from "./EventPopup";
import Slideshow from "./Slideshow";

//The Matterport tour is heavy, so it only loads when the visitor asks for it (Wix loaded it with the page)
const VenueTour = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  return (
    <section
      className={"home-tour"}
      aria-labelledby={"tour-title"}
    >
      <div className={"container"}>
        <SectionTitle id={"tour-title"}>{HOME.TOUR.TITLE}</SectionTitle>
        <p className={"section-intro"}>{HOME.TOUR.TEXT}</p>
      </div>
      <div className={"container-wide"}>
        <div className={"home-tour-frame"}>
          {isLoaded ? (
            <iframe
              src={`${TOUR_LINK}&play=1`}
              title={"3D tour of The Estia Crystal Room"}
              allow={"fullscreen; xr-spatial-tracking"}
              allowFullScreen
            />
          ) : (
            <button
              type={"button"}
              className={"home-tour-start"}
              onClick={() => setIsLoaded(true)}
            >
              <img
                src={"/images/slides/slide-2.webp"}
                alt={""}
                width={1536}
                height={1024}
                loading={"lazy"}
              />
              <span className={"home-tour-play"}>
                <svg
                  viewBox={"0 0 24 24"}
                  aria-hidden={"true"}
                >
                  <path d={"M8 5v14l11-7z"} />
                </svg>
                Start the 3D tour
              </span>
            </button>
          )}
        </div>
        <p className={"home-tour-note"}>
          <a
            href={TOUR_LINK}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            Open the tour full screen in a new tab
          </a>
        </p>
      </div>
    </section>
  );
};

const Home = () => (
  <React.Fragment>
    <PageMeta title={HOME.META_TITLE} />
    <Slideshow>
      <img
        src={"/images/logo-mark.png"}
        alt={""}
        width={520}
        height={520}
        className={"home-hero-mark"}
      />
      <div className={"home-hero-text"}>
        <h1 className={"home-hero-title"}>{HOME.HERO.TITLE}</h1>
        <p>{HOME.HERO.TEXT}</p>
      </div>
    </Slideshow>
    <CardSection {...HOME.NEWS} />
    <CardSection {...HOME.COORDINATION} />
    <CardSection {...HOME.QUALITY} />
    <VenueTour />
    <Nightmares />
    <EventPopup />
  </React.Fragment>
);

export default Home;
